import React from "react"
import {HalfSizeTeaser} from "./HalfSizeTeaser.jsx";
import {TextTeaser} from "./TextTeaser.jsx";
import {ErrorTeaser} from "./ErrorTeaser.jsx";

/**
 * @typedef {Object} DuplexTeaserModel
 * @property {'DUPLEX_TEASER'} type
 * @property {(HalfSizeTeaserModel | ErrorTeaserModel | TextTeaserModel | null)[]} content
 */

/**
 * @typedef {import("./ArticleOverviewTeaserContent.jsx").Device} Device
 */

/**
 * @param {DuplexTeaserModel} model
 * @param {Device} device
 * @returns {JSX.Element}
 */
export function DuplexTeaser({model, device}) {
    return <div className="content-platform__teaser content-platform__teaser--duplex">
        {model.content.map(teaser => (
            teaser && teaser.entryId && <SubTeaser key={teaser.entryId} model={teaser} device={device}/>
        ))}
    </div>
}

/**
 * @param {TextTeaserModel|HalfSizeTeaserModel|ErrorTeaserModel} model
 * @param {Device} device
 * @returns {JSX.Element}
 */
export function SubTeaser({model, device}) {
    switch (model.type) {
        case 'TEXT_TEASER':
            return <TextTeaser model={model} device={device}/>
        case 'HALF_SIZE_TEASER':
            return <HalfSizeTeaser model={model} device={device}/>
        case 'ERROR_TEASER':
            return <ErrorTeaser model={model} device={device}/>

        default:
            return null
    }
}